define("SDB.DisplayVehicle.View", [
  "SCView",
  "sdb_display_vehicle.tpl",
  "SDB.SelectWheelsOrTires.SS2Model",
  "SDB.Modal.Content.View",
  "SDB.SelectYourVehicle.View",
  "Utils",
  "SDB.GetSOVehicleIDs.SS2Model",
  "LiveOrder.Model",
  "Profile.Model",
  "SDB.SDBLocations.Model",
  "sdb_select_vehicle_checkout_module.tpl",
], function (
  SCViewModule,
  sdb_display_vehicle_tpl,
  SDBSelectWheelsOrTiresSS2Model,
  SDBModalContentView,
  SDBSelectYourVehicleView,
  Utils,
  SOVehicleIDsModel,
  LiveOrderModel,
  ProfileModel,
  LocationsModel,
  sdb_select_vehicle_checkout_module_tpl
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  var SDBDisplayVehicleView = function SDBDisplayVehicleView(options) {
    SCView.call(this);
    var self = this;

    this.options = options || {};
    this.template = sdb_display_vehicle_tpl;
    this.layout = this.options.container.getComponent("Layout");
    this.model = SDBSelectWheelsOrTiresSS2Model.getInstance();
    var LiveOrder = LiveOrderModel.getInstance();
    var Profile = ProfileModel.getInstance();
    var SOVehicleIDs = SOVehicleIDsModel.getInstance();
    var Locations = LocationsModel.getInstance();
    /** @type {CheckoutComponent} */
    var Checkout = this.options.container.getComponent("Checkout");

    this.showModal = function () {
      if (Checkout) return;
      this.modalView = new SDBModalContentView({
        parentView: this,
        contentView: SDBSelectYourVehicleView,
        container: this.options.container,
        pageHeader: "Select Your Vehicle",
        isMake: this.options.isMake,
      });
      self.layout.showContent(self.modalView, { showInModal: true });
    };
    this.events = {
      "click .vehicle-selector__header": "showModal",
    };

    this.getContext = function getContext() {
      var vehicleString = self.model.get("vehicle");
      var isMobile = Utils.getDeviceType() !== "desktop" || false;
      if (!vehicleString) return { isMobile: isMobile };
      if (vehicleString) {
        this.vehicle = JSON.parse(vehicleString);

        return {
          vehicle: this.vehicle,
          isMobile: isMobile,
        };
      }
    };

    this.model.on("change:vehicle", this.render, this);

    this.setTransactionFields = function setTransactionFields(isLoggedIn) {
      var _vehicle;
      if (!isLoggedIn) isLoggedIn = Profile.get("isLoggedIn");
      var alreadySet = SOVehicleIDs.get("transactionFieldsSet");
      if (isLoggedIn != "T" || alreadySet) return;
      SOVehicleIDs.set("transactionFieldsSet", true);
      Locations.set("finishedAddressManagement", false);
      var cookies = document.cookie.split(";");
      if (cookies && cookies.length > 1) {
        var vehicle = cookies.find(function (cookie) {
          return cookie.indexOf("vehicle=") !== -1;
        });
        if (vehicle) vehicle = vehicle.split("=")[1];

        // vehicleConfigId from RS API on the vehicle selection modal
        var rideStylerVehicleConfigId = cookies.find(function (cookie) {
          return cookie.indexOf("vehicleConfig=") !== -1;
        });
        if (rideStylerVehicleConfigId) {
          rideStylerVehicleConfigId = rideStylerVehicleConfigId.split("=")[1];
        }
      }
      if (!vehicle) {
        SOVehicleIDs.set("transactionFieldsSet", true);
        Locations.on(
          "change:finishedAddressManagement",
          function (model, value) {
            if (!value) return;
            var options = LiveOrder.get("options");
            options.custbody_sdb_so_year = "";
            options.custbody_sdb_so_make = "";
            options.custbody_sdb_so_model = "";
            options.custbody_cca_ymms = "46101"; // OPT Out Of Vehicle Selection
            LiveOrder.save();
          }
        );
        return;
      }

      vehicle = JSON.parse(vehicle);
      var yearLabel = vehicle.year;
      var makeLabel = vehicle.make;
      var modelLabel = vehicle.model;
      if (!yearLabel || !makeLabel || !modelLabel) {
        SOVehicleIDs.set("transactionFieldsSet", false);
        return;
      }

      SOVehicleIDs.fetch({
        async: false,
        data: {
          year: yearLabel,
          make: makeLabel,
          model: modelLabel,
          rsVehicleConfigId:
            rideStylerVehicleConfigId ||
            ((_vehicle = vehicle) === null || _vehicle === void 0
              ? void 0
              : _vehicle.config) ||
            null,
        },
      })
        .then(function (result) {
          if (!result || result.indexOf("<title>Notice</title>") != -1) {
            console.log("Error:", "SO Vehicle IDs Not Found");
            SOVehicleIDs.set("transactionFieldsSet", false);
            return;
          }
          self.data = JSON.parse(result);
          Locations.on(
            "change:finishedAddressManagement",
            function (model, value) {
              if (!value) {
                SOVehicleIDs.set("transactionFieldsSet", false);
                return;
              }
              var data = self.data;
              var options = LiveOrder.get("options");
              options.custbody_sdb_so_year = data.year;
              options.custbody_cca_ymms = data.ymms || "46101"; // OPT Out Of Vehicle Selection
              self.somake = data.make;
              self.somodel = data.model;
              // console.log('starting', 'first vehicle save')
              LiveOrder.save().then(function () {
                var options = LiveOrder.get("options");
                options.custbody_sdb_so_make = self.somake;
                // console.log('finishing', 'first vehicle save')
                // console.log('starting', 'second vehicle save')
                LiveOrder.save().then(function () {
                  var options = LiveOrder.get("options");
                  options.custbody_sdb_so_model = self.somodel;
                  // console.log('finishing', 'second vehicle save')
                  // console.log('starting', 'third vehicle save')
                  LiveOrder.save();
                  SOVehicleIDs.set("transactionFieldsSet", false);
                });
              });
            }
          );
        })
        .catch(function (error) {
          console.error(error);
        });
    };
    self.setTransactionFields();

    var addSelectVehicleModule = function addSelectVehicleModule() {
      if (moduleAdded || !Checkout || Profile.get("isLoggedIn") != "T") return;
      var cookies = document.cookie.split(";");
      if (cookies && cookies.length > 1) {
        var vehicle = cookies.find(function (cookie) {
          return cookie.indexOf("vehicle=") !== -1;
        });
        if (vehicle) vehicle = vehicle.split("=")[1];
      }
      if (vehicle) return;
      Checkout.getCurrentStep().then(function (step) {
        if (moduleAdded) return;
        if (!step || (step.url != "shipping/address" && step.url != "opc"))
          return;
        moduleAdded = true;

        Checkout.addModuleToStep({
          step_url: step.url,
          module: {
            id: "SelectVehicle",
            index: 49,
            classname: "SelectYourVehicle.SelectVehicle",
            options: {
              template: sdb_select_vehicle_checkout_module_tpl,
              config: self.options.container
                .getComponent("Environment")
                .getConfig("SDBFindPerfectFit".concat(".", "Vehicle")),
            },
          },
        });
      });
      Checkout.on("afterSetCurrentStep", function (step) {
        if (step != "review") return;
        var selectYear = document.querySelector(
          "#select-vehicle-checkout-year"
        );
        var selectMake = document.querySelector(
          "#select-vehicle-checkout-make"
        );
        var selectModel = document.querySelector(
          "#select-vehicle-checkout-model"
        );
        self.selectedVehicle = {};
        if (selectYear)
          self.selectedVehicle.year =
            selectYear.options[selectYear.selectedIndex].label;
        if (selectMake)
          self.selectedVehicle.make =
            selectMake.options[selectMake.selectedIndex].label;
        if (selectModel)
          self.selectedVehicle.model =
            selectModel.options[selectModel.selectedIndex].label;
        SOVehicleIDs.fetch({
          async: false,
          data: self.selectedVehicle,
        })
          .then(function (result) {
            if (!result || result.indexOf("<title>Notice</title>") != -1) {
              console.log("Error:", "SO Vehicle IDs Not Found");
              return;
            }
            var data = JSON.parse(result);
            if (!data.year) return;
            var options = LiveOrder.get("options");
            options.custbody_sdb_so_year = data.year;
            self.somake = data.make;
            self.somodel = data.model;
            LiveOrder.save().then(function () {
              if (!self.somake) return;
              var options = LiveOrder.get("options");
              options.custbody_sdb_so_make = self.somake;
              LiveOrder.save().then(function () {
                if (!self.somodel) return;
                var options = LiveOrder.get("options");
                options.custbody_sdb_so_model = self.somodel;
                LiveOrder.save();
              });
            });
          })
          .catch(function (err) {
            console.log(err);
            self.error = "Error setting values on the transaction";
            self.render();
          });
      });
    };

    // This is replaced by setting the YYMS field on transactions
    // if (Checkout) Checkout.on('afterShowContent', function () {
    //     addSelectVehicleModule();
    // })
  };
  var moduleAdded;

  SDBDisplayVehicleView.prototype = Object.create(SCView.prototype);
  SDBDisplayVehicleView.prototype.constructor = SDBDisplayVehicleView;

  return SDBDisplayVehicleView;
});
